'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/has/src/index.js
// module id = 1287
// module chunks = 2